import useAccountManagementStore from "../../../stores/accountManagementStore";
import useMainStore from "../../../stores/mainStore";
import useTextFilesStore from "../../../stores/textFilesStore";
import { saveTextFile } from "../../cache/manageTextFile";
import getTextFile from "./getTextFile";

export default async function loadTextBucketIntoCache(
    noteID: string,
    newDate?: boolean
) {
    const userID = useAccountManagementStore.getState().userData.id;

    if (!userID || userID === "default")
        return;
    const textFile = await getTextFile(noteID);

    if (!textFile) return;

    // If note is new, add it to the store
    if (!newDate) useTextFilesStore.getState().saveContent(noteID, textFile, true);
    // If note is not new, set it's content
    else {
        // If note being updated is open, set the content.
        if (useMainStore.getState().data.selectedNoteID === noteID) {
            window.editorRef?.current.commands.setContent(textFile, false);
        }

        useTextFilesStore.getState().setTextFile(noteID, textFile);

        // Save the text file (save to cache)
        saveTextFile(noteID, textFile);
    }
}
